/*
  Scent swatches in place on the ad landing pages (sections/featured-product.liquid, "Swap view").

  A click on another product in the product variations block normally opens that product page. In a featured product
  section with data-swap-view, the product is fetched through the alternate product template instead
  (/products/<handle>?view=<swap view>; the section whose id ends in __<swap section>) and its product block replaces this one, so the
  visitor stays on the landing page. Only the <product-rerender> part is swapped: the section wrapper (anchor #buy, the
  styles for this section) stays, and the fetched section id is rewritten to this section's id so form ids, the product
  rerender id and the gallery ids line up with the page.
*/

const fetchProduct = async (link, wrapper) => {
  const url = new URL(link.href);
  url.hash = '';
  url.searchParams.set('view', wrapper.dataset.swapView);

  const response = await fetch(url, { credentials: 'same-origin' });
  if (!response.ok) throw new Error(`Swap failed (${response.status})`);

  return new DOMParser().parseFromString(await response.text(), 'text/html');
};

document.addEventListener('click', async (event) => {
  const link = event.target.closest?.('[data-swap-view] [data-block-type="product-variations"] a[href*="/products/"]');

  if (!link || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;

  const wrapper = link.closest('[data-swap-view]');
  const section = wrapper.closest('.shopify-section');
  const current = wrapper.querySelector('product-rerender');

  if (!section || !current) return;

  event.preventDefault();

  // The swatch's inline handler prepares a scroll restore for the next page load; there is no page load here
  sessionStorage.removeItem('variationsInteraction');
  sessionStorage.removeItem('previousScrollPosition');

  wrapper.setAttribute('aria-busy', 'true');

  try {
    const doc = await fetchProduct(link, wrapper);
    // A JSON template's section id carries the theme's template id (template--<id>__buy), so match on the ending
    const key = wrapper.dataset.swapSection || 'buy';
    const fetchedSection = doc.querySelector(`.shopify-section[id$="__${CSS.escape(key)}"]`);
    const fetched = fetchedSection?.querySelector('product-rerender');

    if (!fetched) throw new Error('No product in the swap view');

    const fetchedId = fetchedSection.id.replace('shopify-section-', '');
    const ownId = section.id.replace('shopify-section-', '');
    const html = fetched.outerHTML.split(fetchedId).join(ownId);

    const top = wrapper.querySelector('[data-block-type="product-variations"]')?.getBoundingClientRect().top;
    current.outerHTML = html;
    document.dispatchEvent(new CustomEvent('featured-product:swapped', { detail: { section } }));

    // Keep the swatches where the visitor clicked them
    const swatches = wrapper.querySelector('[data-block-type="product-variations"]');
    if (swatches && top !== undefined) {
      window.scrollBy({ top: swatches.getBoundingClientRect().top - top, behavior: 'instant' });
    }
  } catch (error) {
    // Fall back to the product page
    window.location.href = link.href;
  } finally {
    wrapper.removeAttribute('aria-busy');
  }
});
